// extracted by mini-css-extract-plugin
export default {"guessPegRow":"GuessPegRow_guessPegRow__tUM8y","currentGuess":"GuessPegRow_currentGuess__BmkFU"};